import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { error } from "../../utils/logging/logging";
import { TextLoca } from "../generic/text/TextLoca";
import { teaserLocaMap } from "./teaserLocaMap";
export var TournamentTeaserDescription = function (_a) {
    var type = _a.type, replacementLevelString = _a.replacementLevelString;
    var replacements = new Map([
        [ReplacementLoca.zero_0, replacementLevelString.toString()],
    ]);
    try {
        var description = teaserLocaMap.get(type).description;
        return (React.createElement(TextLoca, { className: IdStyles.TextNormal, id: description, replacements: replacements }));
    }
    catch (_b) {
        error("You didn't add a case scenario into TabTournament's map.");
        return React.createElement(React.Fragment, null);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/TournamentTeaserDescription.tsx
// module id = 2779
// module chunks = 3